import { emptyArray } from 'ui-components/default-props/empty';
import { presetService } from '../../services/preset-service';
import Global from '../global-selectors';

export class FulfillmentPlannerProperties {
  constructor({ state, fulfillmentPlanId }) {
    if (!state) {
      throw new Error(`expected value for state, got: ${state}`);
    }
    if (!fulfillmentPlanId) {
      throw new Error(`expected value for fulfillmentPlanId, got: ${fulfillmentPlanId}`);
    }

    this.state = state;
    this.fulfillmentPlanId = fulfillmentPlanId;
  }

  get salesOrderId() {
    const { state, fulfillmentPlanId } = this;
    return Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'salesOrdersFulfilledIds.0',
    });
  }

  get requestedShippingServiceCode() {
    const { state, fulfillmentPlanId } = this;
    return Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'marketplaceData.requestedService',
    });
  }

  get storeId() {
    const { state, salesOrderId } = this;
    return Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'store.storeGuid',
    });
  }

  get requestedShippingServiceMapping() {
    const { state, storeId, requestedShippingServiceCode } = this;
    const serviceMapping = Global.selectSellerRequestedServiceMapping(state, {
      storeGuid: storeId,
      requestedServiceCode: requestedShippingServiceCode,
    });
    if (serviceMapping) {
      return {
        isMapped: true,
        requestedServiceCode: serviceMapping.requestedServiceCode,
        serviceCollectionGuid: serviceMapping.serviceCollectionGuid,
        serviceId: serviceMapping.serviceId,
        packageTypeId: serviceMapping.packageTypeId,
        storeId,
      };
    }
    return {
      isMapped: false,
      requestedServiceCode: requestedShippingServiceCode,
      storeId,
    };
  }

  get sellerCurrencyCode() {
    const { state } = this;
    return Global.selectSellerDefaultCurrency(state) || 'USD';
  }

  get presets() {
    const { state } = this;
    const packages = Global.selectSellerPackages(state) || emptyArray;
    const presets = Global.selectSellerPresets(state);
    const services = Global.selectSellerServices(state) || emptyArray;
    const sellerLabelProviders = Global.selectSellerLabelProviders(state);
    return presets
      .map((preset) => presetService.mapPresetToKeyValue(preset, packages, services, sellerLabelProviders))
      .sort((preset) => preset.sortOrder);
  }
}
